<template>
	<validation-observer v-slot="{ invalid }" ref="form" class="form mx-auto">
		<b-form @submit.prevent="submitForm">
			<slot name="header">
				<h4 class="mb-4">Manage User</h4>
			</slot>

			<base-input
				v-model="models.email"
				name="Email Address"
				label="Email Address"
				disabled
			></base-input>

			<base-input
				v-model="models.display_name"
				rules="required"
				name="Name"
				label="Name"
			></base-input>

			<div class="mt-4 d-flex justify-content-between">
				<slot name="return"></slot>
				<slot name="submit">
					<base-button
						:disabled="invalid"
						:loading="formProcessing"
						type="primary"
						native-type="submit"
						size="md"
						class="form-btn font-weight-normal"
					>
						<slot name="submit-text">Save</slot>
					</base-button>
				</slot>
			</div>
		</b-form>
	</validation-observer>
</template>

<script>
export default {
	name: "form-user-name",
	inject: ["memberSvc", "ErrorService"],
	data() {
		return {
			formProcessing: false,
			models: {},
		};
	},
	watch: {
		"memberSvc.member": {
			deep: true,
			immediate: true,
			handler: function (val) {
				this.models = {
					id: val.id,
					email: val.user_email,
					display_name: val.user.first_name,
				};
			},
		},
		formProcessing: function (val) {
			this.$bus.$emit("user-name-form-processing", val);
		},
	},
	methods: {
		async submitForm() {
			this.formProcessing = true;

			const response = await this.memberSvc.update(this.models);

			if (200 === response.data.status)
				this.$bus.$emit(
					"user-name-form-success",
					response.data.data.data
				);

			this.$toasted.show(response.data.data.message);

			this.reset();
		},
		reset() {
			this.formProcessing = false;

			this.$refs.form.reset();
		},
	},
	mounted() {
		this.ErrorService.stopProcessingOnFail(this);
	},
	beforeDestroy() {
		this.memberSvc.set("member", null);

		this.reset();
	},
};
</script>
